// =========================================================================
// F08 G2 · Reanudación del onboarding — regla de decisión PURA
// =========================================================================
// El bug que corrige: `handleLogin`/`autoLogin` enrutaban SIEMPRE a `app`; el
// onboarding solo aparecía en el registro cuando `session.isNew`. Un usuario
// nuevo que cerraba la app a mitad del wizard entraba directo a `app` en el
// siguiente login y se saltaba el onboarding para siempre.
//
// La señal de completitud es un HITO DE PERFIL (`onboardingCompletedAt`), NO la
// admisión/activación clínica (eso lo decide la valoración/elegibilidad y es
// Tier-2). Aquí solo se responde: «¿terminó las pantallas del wizard?».

import type { Usuario } from '@/services';

/** Subconjunto del perfil que basta para decidir. Facilita el test. */
export type PerfilOnboarding = Pick<Usuario, 'onboardingCompletedAt' | 'goal'>;

/**
 * ¿Hay que enviar a este usuario al wizard de onboarding?
 *
 * Regla (solo enruta a onboarding cuando faltan AMBAS señales):
 *  - `onboardingCompletedAt` presente ⇒ ya lo completó (camino nuevo).
 *  - `goal` presente ⇒ COMPAT hacia atrás: un perfil anterior al flag que ya
 *    pasó por el wizard tiene `goal` (solo `finalizar` lo escribe). Se respeta
 *    como onboarded para no re-onboardear a usuarios existentes.
 *
 * La dirección del sesgo es deliberada: ante duda, NO atrapar al usuario en el
 * wizard. Solo un perfil sin flag Y sin `goal` (perfil mínimo recién creado que
 * nunca terminó) se manda a onboarding.
 */
export function necesitaOnboarding(perfil: PerfilOnboarding | null | undefined): boolean {
  if (!perfil) return false; // sin perfil legible ⇒ no forzar onboarding (fail-safe)
  const completado = !!perfil.onboardingCompletedAt || !!perfil.goal;
  return !completado;
}
